module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-ExtraBold-67b4561b9c15a0bb7d6e94895ce9b881.woff2";